import React, {lazy} from "react";

// MODULES
const Welcome = lazy(() => import("../domains/user/welcome/Welcome"));
const User = lazy(() => import("../domains/user/account/User"));
const Easeedesk = lazy(() => import("../domains/easeedesk"));
const Easeetask = lazy(() => import("../domains/easeetask"));
const Inventoree = lazy(() => import("../domains/inventoree/Inventoree"));
const Opteemum = lazy(() => import("../domains/opteemum/Opteemum"));
const Overview = lazy(() => import("../domains/overview/Overview"));
const Printeeng = lazy(() => import("../domains/printeeng/Printeeng"));
const Proactivitee = lazy(() => import("../domains/proactivitee/Proactivitee"));
const Productivitee = lazy(() => import("../domains/productivitee/Productivitee"));
const Protectee = lazy(() => import("../domains/protectee/Protectee"));
const Saveenergee = lazy(() => import("../domains/saveenergee/Saveenergee"));
const Securitee = lazy(() => import("../domains/securitee/Securitee"));
const Softsee = lazy(() => import("../domains/softsee/Softsee"));

// ASIDE MENU
const DefaultMenuList = lazy(() => import("../layout/components/aside/aside-menu/DefaultMenuList"));
const EaseedeskMenuList = lazy(() => import("../domains/easeedesk/_components/EaseedeskMenuList"));
const EaseetaskMenuList = lazy(() => import("../domains/easeetask/_components/EaseetaskMenuList"));
const InventoreeMenuList = lazy(() => import("../domains/inventoree/_components/InventoreeMenuList"));
const OverviewMenuList = lazy(() => import("../domains/overview/_components/OverviewMenuList"));
const OpteemumMenuList = lazy(() => import("../domains/opteemum/_components/OpteemumMenuList"));
const PrinteengMenuList = lazy(() => import("../domains/printeeng/_components/PrinteengMenuList"));
const ProactiviteeMenuList = lazy(() => import("../domains/proactivitee/_components/ProactiviteeMenuList"));
const ProductiviteeMenuList = lazy(() => import("../domains/productivitee/_components/ProductiviteeMenuList"));
const SoftseeMenuList = lazy(() => import("../domains/softsee/_components/SoftseeMenuList"));
const ProtecteeMenuList = lazy(() => import("../domains/protectee/_components/ProtecteeMenuList"));
const SecuriteeMenuList = lazy(() => import("../domains/securitee/_components/SecuriteeMenuList"));
const SaveenergeeMenuList = lazy(() => import("../domains/saveenergee/_components/SaveenergeeMenuList"));

const routes = [
    {
        path: "/welcome",
        exact: false,
        main: () => <Welcome/>,
        menu: ({layoutProps}) => <DefaultMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/user",
        exact: false,
        main: () => <User/>,
        menu: ({layoutProps}) => <DefaultMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/easeedesk",
        exact: false,
        main: () => <Easeedesk/>,
        menu: ({layoutProps}) => <EaseedeskMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/easeetask",
        exact: false,
        main: () => <Easeetask/>,
        menu: ({layoutProps}) => <EaseetaskMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/inventoree",
        exact: false,
        main: () => <Inventoree/>,
        menu: ({layoutProps}) => <InventoreeMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/overview",
        exact: false,
        main: () => <Overview/>,
        menu: ({layoutProps}) => <OverviewMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/opteemum",
        exact: false,
        main: () => <Opteemum/>,
        menu: ({layoutProps}) => <OpteemumMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/printeeng",
        exact: false,
        main: () => <Printeeng/>,
        menu: ({layoutProps}) => <PrinteengMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/proactivitee",
        exact: false,
        main: () => <Proactivitee/>,
        menu: ({layoutProps}) => <ProactiviteeMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/productivitee",
        exact: false,
        main: () => <Productivitee/>,
        menu: ({layoutProps}) => <ProductiviteeMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/protectee",
        exact: false,
        main: () => <Protectee/>,
        menu: ({layoutProps}) => <ProtecteeMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/saveenergee",
        exact: false,
        main: () => <Saveenergee/>,
        menu: ({layoutProps}) => <SaveenergeeMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/securitee",
        exact: false,
        main: () => <Securitee/>,
        menu: ({layoutProps}) => <SecuriteeMenuList layoutProps={layoutProps}/>,
    },
    {
        path: "/softsee",
        exact: false,
        main: () => <Softsee/>,
        menu: ({layoutProps}) => <SoftseeMenuList layoutProps={layoutProps}/>,
    },
];

export default routes;
